import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-kit-tabs-header',
  templateUrl: 'tabs-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsHeaderComponent {
  // @ts-expect-error
  @Input() separate: boolean;
  constructor() {}
}
